import { createSlice } from '@reduxjs/toolkit';
import { defaultApiState } from '../../common/constants/api-constants';
import { PromoCodeDiscountState } from './interfaces/promo-code.interface';
import { ActionStatus } from '../../common/constants/action-status';
import { updatePromoCode } from '../cart/shop-cart/thunks/update-promo-code.thunk';
import { deletePromoCode } from '../cart/shop-cart/thunks/delete-promo-code.thunks';
import { addRedeemUpsellOfferReducers } from '../upsell/store/redeem-upsell-offer.store';

/*----- CREATE INITIAL STATE ------*/

export const PromoCodeDiscountStateInitialState: PromoCodeDiscountState = {
  updatePromoCode: defaultApiState,
  deletePromoCode: defaultApiState
};

/*----- CREATE STORE SLICE ------*/

export const promoCodeDiscountSlice = createSlice({
  name: 'promoCodeDiscount',
  initialState: PromoCodeDiscountStateInitialState,
  reducers: {
    setPromoCode(state, action) {
      if (state.updatePromoCode.data) {
        state.updatePromoCode.data.coupon = action.payload;
      }
    },
    resetPromoCode(state) {
      state.updatePromoCode = defaultApiState;
      state.deletePromoCode = defaultApiState;
    }
  },
  extraReducers(builder) {
    builder
      .addCase(updatePromoCode.pending, (state) => {
        state.updatePromoCode.status = ActionStatus.loading;
      })
      .addCase(updatePromoCode.fulfilled, (state, action) => {
        state.updatePromoCode.status = ActionStatus.succeeded;
        state.updatePromoCode.data = action.payload;
        state.updatePromoCode.error = undefined;
      })
      .addCase(updatePromoCode.rejected, (state, action: any) => {
        state.updatePromoCode.status = ActionStatus.failed;
        state.updatePromoCode.data = {
          promoDiscount: undefined,
          currencyCode: undefined,
          coupon: action.payload.promoCode
        }
        state.updatePromoCode.error = action.payload.message;
      })
      .addCase(deletePromoCode.pending, (state) => {
        state.deletePromoCode.status = ActionStatus.loading;
      })
      .addCase(deletePromoCode.fulfilled, (state) => {
        state.deletePromoCode.status = ActionStatus.succeeded;
      })
      .addCase(deletePromoCode.rejected, (state) => {
        state.deletePromoCode.status = ActionStatus.failed;
      });
    addRedeemUpsellOfferReducers(builder);
  }
});

/*----- CREATE SLICE ACTIONS ------*/

export const { setPromoCode } = promoCodeDiscountSlice.actions
export const { resetPromoCode } = promoCodeDiscountSlice.actions

/*----- CREATE REDUCER ------*/

export const promoCodeDiscountReducer = promoCodeDiscountSlice.reducer;


